import React, { useEffect } from 'react';
import { useFormContext } from 'context/FormDrawerContext/FormDrawerContext';
import { useRouteMatch } from 'react-router-dom';
import { FormMatchParams } from '../FormDrawer';

interface FromStepWrapperProps {
  children: React.ReactNode;
}

const FromStepWrapper: React.FC<FromStepWrapperProps> = ({ children }) => {
  const { setCurrentStep } = useFormContext();
  const { params } = useRouteMatch<FormMatchParams>();

  useEffect(() => {
    if (params.stepId) setCurrentStep(parseInt(params.stepId, 10));
  }, []);

  return <div className='relative w-full flex h-full pt-5'>{children}</div>;
};

export default FromStepWrapper;
